import { DEFAULT_ROUTE_PATH, ROUTES } from '#constants/routes';
import { currentRouteExists, getCurrentRoute } from '#utils/routes';

import { isLogged, mapExpirationTime } from './session';

const getLoginPath = (pathname, search) => {
  const searchQueryParam = search ? `&${search.substring(1)}` : '';
  return {
    pathname: ROUTES.LOGIN.path,
    search: pathname === '/' ? '' : `?redirectTo=${pathname}${searchQueryParam}`
  };
};

export const isActualPath = path => () => window.location.pathname === path;

export const isActualPathAdelphiMenu = isActualPath(ROUTES.ADELPHI_MAIN_MENU.path);

export const mapRedirects = (tokenManager, pathname, search) => {
  const defaultPath = DEFAULT_ROUTE_PATH[tokenManager?.role];
  const login = getLoginPath(pathname, search);

  return { login, defaultPath };
};

export const getLoggedUserRedirect = ({ privateRoute, access, defaultPath }) =>
  !(privateRoute && access) && defaultPath;

export const isActualPathHome = () => window.location.pathname === ROUTES.HOME.path;

export const isValidActualPath = () =>
  Object.values(ROUTES)
    .map(({ path }) => path)
    .includes(window.location.pathname);

export const showActualRoute = (tokenManager, pathname) => {
  const {
    publicRoute,
    loginRoute,
    privateRoute = !(publicRoute || loginRoute)
  } = getCurrentRoute(pathname) || {};
  const expirationTime = tokenManager && mapExpirationTime(tokenManager.expirationTime);
  const logged = isLogged(expirationTime);
  if (loginRoute) {
    return logged ? 'ADELPHI_MAIN_MENU' : '';
  } else if (publicRoute) {
    return '';
  } else if (privateRoute && currentRouteExists(pathname)) {
    return logged ? '' : 'LOGIN';
  }
  return 'HOME';
};
